import { useDispatch } from "react-redux";
import { setSelectedCar } from "../../../redux/car";
import { useNavigate, useSearchParams } from "react-router-dom";
import { APP_PATHS } from "../../../constants/paths";
import "./SkuDetailsTable.css"; // Import custom CSS

const SkuDetailsTable = (props) => {
  const {
    cars,
    subCategoryId,
    categoryDetails: { id: categoryId, name: categoryName },
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const filterSelectedCar = (car) => {
    const {
      brandId,
      brandName,
      modelId,
      modelName,
      cc,
      endYear,
      startYear,
      id,
      transmission,
    } = car;

    dispatch(
      setSelectedCar({
        brand: { brandName, id: brandId },
        model: { modelName, id: modelId },
        year: { startYear, endYear },
        carDetails: { id, cc, transmission },
      })
    );

    searchParams.set("subCategoryId", subCategoryId);
    setSearchParams(searchParams);

    navigate(
      `${APP_PATHS.SKUS}?subCategoryId=${subCategoryId}&categoryId=${categoryId}&categoryName=${categoryName}`
    );
  };

  return (
    <div className="max-h-96 overflow-auto custom-scrollbar">
      <table className="w-full text-sm">
        <thead className="w-full bg-light-gray rounded-tr-lg rounded-tl-lg text-#677181">
          <tr>
            <th className="rounded-tr-lg py-2">الماركة</th>
            <th>الموديل</th>
            <th>السنة</th>
            <th>الفتيس</th>
            <th className="rounded-tl-lg">السي سي</th>
          </tr>
        </thead>
        <tbody className="w-full">
          {cars.map((car, index) => (
            <tr
              key={index}
              onClick={() => filterSelectedCar(car)}
              className={`cursor-pointer hover:bg-blue-100 transition ${
                index !== cars.length - 1 ? "border-b border-light-gray" : ""
              }`}
            >
              <td className="text-center py-2">{car.brandName}</td>
              <td className="text-center">{car.modelName}</td>
              <td className="text-center">{`${car.startYear}-${car.endYear}`}</td>
              <td className="text-center">{car.transmission}</td>
              <td className="text-center">{car.cc}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SkuDetailsTable;
